<template lang="pug">
  div.modal-bg(@click="closeModal")
    div.upload-heatmap-image(@click.stop)
      div
        p.mb-0 Webサイト画像アップロード
        span#modal-close(@click="closeModal")
      div
        p.ml-3.mt-2.mb-1 Webサイトの画像（スクリーンショット）を手動で
        p.ml-3 アップロードし、ヒートマップに反映することができます。
        p.ml-3.mt-3.mb-1 ●Freeプラン・Basicプランの場合
        p.ml-5.mb-1 アップロードされたWebサイト画像に更新されます。
        p.ml-3.mb-1 ●Masterプラン以上の場合
        p.ml-5 アップロードされたWebサイト画像が追加保存されます。

      div.d-flex.justify-content-center.mb-2
        label(for="sp_file").mr-2 SP用
        input#sp_file(type="file" accept="image/jpeg, image/png" @change="onSpFileChange")
      div.d-flex.justify-content-center.mb-2
        label(for="pc_file").mr-2 PC用
        input#pc_file(type="file" accept="image/jpeg, image/png" @change="onPcFileChange")

      div.d-flex.justify-content-center
        a.mb-2.btn-sm(style="cursor: pointer;" @click.prevent="uploadImages") アップロード
</template>

<script>
export default {
  props: {
    token: { type: String, default: "" },
    heatmap_id: { type: Number, default: 0 },
  },
  data() {
    return {
      pc_image: null,
      sp_image: null,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    onPcFileChange(event) {
      this.pc_image = event.target.files[0];
    },
    onSpFileChange(event) {
      this.sp_image = event.target.files[0];
    },
    async uploadImages() {
      if (!this.sp_image && !this.pc_image) {
        alert("少なくとも1つの画像を選択してください");
        return;
      }

      this.$emit("set-loading", true);
      this.$emit("close-modal");

      const formData = new FormData();
      formData.append("heatmap[id]", this.heatmap_id);
      if (this.sp_image) formData.append("heatmap[sp_image]", this.sp_image);
      if (this.pc_image) formData.append("heatmap[pc_image]", this.pc_image);

      try {
        const response = await fetch(`/users/heatmaps/${this.token}/image_upload`, {
          method: "PATCH",
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
        });
        const data = await response.json();

        if (response.ok) {
          this.$toasted.success(data.message);
          await sleep(1000);
          window.location.reload();
        } else {
          this.$toasted.error(data.message);
          await sleep(3000);
          this.$emit("set-loading", false);
        }
      } catch (error) {
        this.$toasted.error("アップロードが失敗しました。");
        await sleep(3000);
        this.$emit("set-loading", false);
      } finally {
        this.$toasted.clear();
      }
    },
  },
};

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
</script>

<style lang="scss" scoped>
.upload-heatmap-image {
  position: fixed;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  z-index: 99999;
  border-radius: 4px;
  width: 500px;
}

.upload-heatmap-image div:first-child {
  border-bottom: solid 1px #000;
  padding: 8px 16px;
}

.upload-heatmap-image div:last-child {
  padding: 8px 16px;
}

.upload-heatmap-image div:last-child a {
  border: none;
  background-color: #28A745;
  color: white;
  border-radius: 4px;
  padding: 4px 16px;
  width: fit-content;
  margin: auto;
}
</style>
